import dayjs from 'dayjs';
import { tldExists } from 'tldjs';
import validator from 'validator';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(CustomParseFormat);
/**
 * @param dateString A date string in YYYY-MM-DD or MM/DD/YYYY format
 * @description Checks if the date is a valid birthday. Returns the date in YYYY-MM-DD format, or null if the date is not valid. **DOES NOT** check if the user is over 18.
 */
export function formatBirthday(dateString) {
  const parsed = dayjs(dateString, ['YYYY-MM-DD', 'MM/DD/YYYY'], true);
  if (!parsed.isValid() || dayjs().diff(parsed, 'years') > 99) return null;
  return parsed.format('YYYY-MM-DD');
}
function notValidString(input) {
  return !input || typeof input !== 'string';
}
/**
 * @param form EAS form data
 * @param formattedBirthday Birthday in YYYY-MM-DD format
 * @description **DOES NOT** check if the user is over 18
 */
export function getFormErrors(form, formattedBirthday) {
  return {
    first_name: notValidString(form.first_name),
    last_name: notValidString(form.last_name),
    email: notValidString(form.email) || !validator.isEmail(form.email) || !tldExists(form.email),
    phone: notValidString(form.phone) || !validator.isMobilePhone(`${form.phone}`.replace('-', ''), 'any', {
      strictMode: false
    }),
    address_street_one: notValidString(form.address.street_one),
    address_street_two: false,
    address_zip_code: notValidString(form.address.zip_code) || !validator.isPostalCode(form.address.zip_code, 'US') || parseInt(form.address.zip_code) < 501,
    address_state: notValidString(form.address.state) || !validator.isLength(form.address.state, {
      min: 2,
      max: 2
    }),
    address_city: notValidString(form.address.city),
    date_of_birth: notValidString(formattedBirthday),
    ssn: notValidString(form.ssn) || !/^\d{3}-?\d{2}-?\d{4}$/.test(form.ssn)
  };
}
export function mapAddressForAPI(address) {
  return {
    street_one: address.street_one,
    street_two: address.street_two,
    locality: address.city,
    region: address.state,
    postal_code: address.zip_code,
    country: 'USA'
  };
}
export const DEFAULT_ADDRESS = {
  street_one: '',
  street_two: '',
  zip_code: '',
  state: '',
  city: ''
};
export const FORM_EMPTY = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  address: DEFAULT_ADDRESS,
  date_of_birth: '',
  ssn: ''
};